















import Vue from 'vue'

export default Vue.extend({
  name: 'lab-switcher',
  props: ['value', 'data'],
  watch: {
    value () {
      try {
        localStorage.setItem('currentLab', this.value)
      } catch (e) {}
    }
  },
  mounted () {
    let stored: string | null = ''
    try {
      stored = localStorage.getItem('currentLab')
    } catch (e) {}

    let index = 0

    if (stored) {
      const keys = this.data.map((item: any) => item.key)
      const indexStored = keys.indexOf(stored)
      if (indexStored !== -1) {
        index = indexStored
      }
    }
    this.setValue(this.data[index].key)
  },
  methods: {
    setValue(key: string) {
      this.$emit('input', key)
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/LabSwitcher.vue